import React, { useState, useEffect } from "react";

const ResendOptions = ({ handleResendCode, autoStart = true }) => {
  const [cooldown, setCooldown] = useState(0);

  // 🔹 Start cooldown on mount (for first API call)
  useEffect(() => {
    if (autoStart && cooldown === 0) {
      setCooldown(60); // Start 30s countdown on first load
    }
  }, [autoStart]);

  // 🔹 Countdown effect
  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => setCooldown((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  // 🔹 Handle resend click
  const handleResendClick = async (e) => {
    e.preventDefault();
    if (cooldown > 0) return; // Prevent resend during cooldown

    await handleResendCode(e);
    setCooldown(60); // Restart timer after resend
  };

  return (
    <div className="text-center w-full max-w-sm mt-4 space-y-3">
      <div className="flex justify-center mt-6">
        <button
          onClick={handleResendClick}
          disabled={cooldown > 0}
          className={`flex items-center space-x-2 border font-medium px-4 py-2 rounded-full text-sm transition-colors duration-200
            ${
              cooldown > 0
                ? "border-gray-400 text-gray-400 cursor-not-allowed"
                : "border-[#003478] text-[#003478] hover:bg-[#003478] hover:text-white"
            }`}
        >
          <span>{cooldown > 0 ? `Resend in ${cooldown}s` : "Resend Code"}</span>
        </button>
      </div>

      <p className="text-xs text-gray-500 mt-2">
        Another code can be requested once the current one is no longer active.
      </p>
    </div>
  );
};

export default ResendOptions;
